<template>
    <div>
      <PointsBar />
      <DaysBarWrapper
        :selectDay="selectedDayEvent"
        :activityLogs="activityLogs"
        :activityHabits="activityHabits"
        :habitsWithLogs="habitsWithLogs"
      />
      <!-- <FriendsSection
        v-if="activityLogs.length > 0 || activityHabits.length > 0"/> -->
      <DayWrapper
        :activityLogs="activityLogs"
        :selectedDay="selectedDay"
        :removeActivityLog="removeActivityLog"
        :editActivityHabits="editActivityHabits"
        :addActivityLog="addActivityLog"
        :addActivityHabits="addActivityHabits"
        :updateActivityLog="updateActivityLog"
        :addRemoveActivityLog="addRemoveActivityLog"
        :habitsWithLogs="habitsWithLogs"
        :user="user"
        :isOnline="isOnline"
      >
      </DayWrapper>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import DaysBarWrapper from './components/DaysBarWrapper.vue';
import DayWrapper from './components/DayWrapper.vue';
import PointsBar from './components/PointsSection/PointsBar.vue';
// import FriendsSection from './components/FriendsSection/FriendsSection.vue';

export default {
  components: {
    DaysBarWrapper,
    DayWrapper,
    PointsBar,
    // FriendsSection,
  },
  data() {
    return {
      dayWrapperLoadingStatus: 'none',
      showTrial: false,
    };
  },
  async beforeMount() {
    // this.dayWrapperLoadingStatus = 'loading';
    // eslint-disable-next-line no-underscore-dangle
    this.selectDay(this.$moment().toISOString());
    const logs = JSON.parse(localStorage.getItem('allLogs'));
    const habits = JSON.parse(localStorage.getItem('allHabits'));
    // if (logs.length > 0 && habits.length > 0) this.dayWrapperLoadingStatus = 'show';
    this.setLogsFromLocalstorage(logs);
    this.setHabitsFromLocalstorage(habits);
    // this.dayWrapperLoadingStatus = 'show';
    // await this.getFriendsEvent(this.selectedDay);
  },
  computed: {
    ...mapState({
      isOnline: (state) => state.applicationStore.isOnline,
      activityLogs: (state) => state.habitsDashboard.activityLogs,
      selectedDay: (state) => state.habitsDashboard.selectedDay,
      activityHabits: (state) => state.habitsDashboard.activityHabits,
      user: (state) => state.userStore.user,
      habitsWithLogs: (state) => state.habitsDashboard.habitsWithLogs,
    }),
  },
  watch: {
    user(e) {
      if (e.uid) {
        const logs = JSON.parse(localStorage.getItem('allLogs'));
        this.getAllLogs(logs);
        this.getAllHabits();
        if (!window.feedbackfin) return;
        window.feedbackfin.config.user.id = e.uid;
      }
    },
  },
  methods: {
    ...mapActions({
      getAllLogs: 'habitsDashboard/getAllLogs',
      addActivityLog: 'habitsDashboard/addActivityLog',
      setLogsFromLocalstorage: 'habitsDashboard/setLogsFromLocalstorage',
      setHabitsFromLocalstorage: 'habitsDashboard/setHabitsFromLocalstorage',
      removeActivityLog: 'habitsDashboard/removeActivityLog',
      addActivityHabits: 'habitsDashboard/addActivityHabits',
      getAllHabits: 'habitsDashboard/getAllHabits',
      editActivityHabits: 'habitsDashboard/editActivityHabits',
      updateActivityLog: 'habitsDashboard/updateActivityLog',
      addRemoveActivityLog: 'habitsDashboard/addRemoveActivityLog',
      selectDay: 'habitsDashboard/selectDay',
      addPoints: 'pointsStore/addPoints',
      getFriends: 'userStore/getFriends',
    }),
    selectedDayEvent(date) {
      // this.getFriendsEvent(date);
      this.selectDay(date);
    },
    async getFriendsEvent() {
      // await this.getFriends(date);
    },
  },
};
</script>
